(function ($) {
    "use strict";

    $(function () {
        $(".modal--gallery").iziModal({
            radius: 0,
            history: false,
            arrowKeys: true,
            navigateCaption: false,
            navigateArrows: false,
            focusInput: false,
            autoOpen: false,
            appendTo: ".modal--gallery",
            appendToOverlay: "body",
            overlay: true,
            overlayClose: true,
            overlayColor: 'rgba(0, 0, 0, 0.8)',
            bodyOverflow: false,
            pauseOnHover: false,
            transitionIn: 'comingIn',
            transitionOut: 'comingOut',
            transitionInOverlay: 'fadeIn',
            transitionOutOverlay: 'fadeOut',
        });
    });

    $('.js-open-gallery').on('click', function (e) {
        e.preventDefault();
        $('.modal--gallery').iziModal('open');
    });

    $(function () {
        $("#modal--video").iziModal({
            onOpening: function (modal) {
                $('.hero-video').get(0).pause();
            },

            onClosing: function (modal) {
                $('.hero-video').get(0).play();
            }
        });
    });

})(jQuery);